// A12 kimliğe bürünme girişi: Admin'in açtığı `/destek-girisi?code=…` bağlantısındaki tek kullanımlık (60 sn) kodu
// belirteçle değiştirir, oturumu ve seçili firmayı yazar, ilgili portala (Operasyon / Kurum) tam yeniden yüklemeyle
// geçer. Kod tekrar kullanılamaz; StrictMode'daki çift efekt aynı isteği paylaşır.
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import type { ImpersonationExchangeResult } from '@serota/domain';
import { Alert, Card, Logo, Skeleton, useThemeMode } from '@serota/ui-web';
import { api, errorText, setCompanyId, tokenStore } from '../lib/api';
import { queryClient } from '../lib/query';

const pending = new Map<string, Promise<ImpersonationExchangeResult>>();

function exchange(code: string): Promise<ImpersonationExchangeResult> {
  let p = pending.get(code);
  if (!p) {
    p = api.post<ImpersonationExchangeResult>('/v1/admin/impersonations/exchange', { code });
    pending.set(code, p);
  }
  return p;
}

export function Impersonate() {
  const [params] = useSearchParams();
  const code = params.get('code');
  const [, , theme] = useThemeMode();
  const [error, setError] = useState<string | null>(
    code ? null : 'Bağlantıda kod yok. SEROTA Yönetim panelinden yeniden başlatın.',
  );

  useEffect(() => {
    if (!code) return;
    let alive = true;
    exchange(code)
      .then(async (r) => {
        if (!alive) return;
        await tokenStore.set({ accessToken: r.accessToken, refreshToken: r.refreshToken });
        setCompanyId(r.companyId);
        queryClient.clear();
        window.location.replace(r.tenantType === 'INSTITUTION' ? '/kurum' : '/operasyon');
      })
      .catch((e) => alive && setError(errorText(e, 'Oturum açılamadı. SEROTA Yönetim panelinden yeniden başlatın.')));
    return () => {
      alive = false;
    };
  }, [code]);

  return (
    <div className="sr-auth">
      <Card className="sr-auth__card" pad="lg">
        <Logo height={28} variant={theme === 'dark' ? 'dark' : 'light'} />
        <h1 className="h1" style={{ marginTop: 28 }}>
          {error ? 'Oturum açılamadı' : 'Panel açılıyor'}
        </h1>
        {error ? (
          <Alert tone="crit" icon="guvenlik" style={{ marginTop: 16 }}>
            {error}
          </Alert>
        ) : (
          <div className="sr-stack" style={{ gap: 10, marginTop: 16 }} aria-busy="true">
            <p className="body sr-muted" style={{ margin: 0 }}>
              SEROTA destek oturumu hazırlanıyor. Bu oturum süreli ve denetim kayıtlıdır.
            </p>
            <Skeleton height={12} width="70%" />
          </div>
        )}
      </Card>
    </div>
  );
}
